// HERZ theme — minimal client behaviour. Calm by design.
(function () {
  'use strict';

  // Product detail: finish selector + tabs (progressive enhancement)
  function initPdp() {
    var finishes = document.querySelectorAll('[data-finish]');
    finishes.forEach(function (el) {
      el.addEventListener('click', function () {
        finishes.forEach(function (f) { f.classList.remove('tag--active'); });
        el.classList.add('tag--active');
        var url = el.getAttribute('data-url');
        if (url) window.location.href = url;
      });
    });

    var tabs = document.querySelectorAll('[data-tab]');
    var panels = document.querySelectorAll('[data-tab-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-tab');
        tabs.forEach(function (t) { t.classList.toggle('tab--active', t === tab); });
        panels.forEach(function (p) {
          p.style.display = p.getAttribute('data-tab-panel') === key ? 'block' : 'none';
        });
      });
    });
  }

  // Collection: filter chips
  function initFilters() {
    var chips = document.querySelectorAll('[data-filter]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var url = chip.getAttribute('data-url');
        if (url) window.location.href = url;
      });
    });
  }

  // In-page anchor links (e.g. hero "Explore" CTA scrolling to the section below):
  // handled manually rather than relying on native hash-scroll, since a same-tick
  // scrollIntoView call can get cancelled by the browser's own post-click handling
  // (focus/pointer settling). Deferring one frame avoids that race.
  function initAnchorScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var id = link.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
      if (history.pushState) history.pushState(null, '', '#' + id);
    });
  }

  // ---- Announcement bar: compact language/currency toggle ----
  function initLocalizationToggle() {
    var widget = document.querySelector('[data-loc-widget]');
    if (!widget) return;
    var toggle = widget.querySelector('[data-loc-toggle]');
    var panel = widget.querySelector('[data-loc-panel]');
    if (!toggle || !panel) return;

    function open() {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (panel.hidden) open(); else close();
    });

    document.addEventListener('click', function (e) {
      if (!panel.hidden && !widget.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) close();
    });
  }

  // ---- PDP size guide lightbox ----
  function initSizeGuideLightbox() {
    var lightbox = document.querySelector('[data-size-guide-lightbox]');
    if (!lightbox) return;

    function open() {
      lightbox.classList.add('pdp__size-guide-lightbox--open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('size-guide-lightbox-locked');
    }
    function close() {
      lightbox.classList.remove('pdp__size-guide-lightbox--open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('size-guide-lightbox-locked');
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-size-guide-open]')) {
        e.preventDefault();
        open();
        return;
      }
      if (e.target.closest('[data-size-guide-close]')) {
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.classList.contains('pdp__size-guide-lightbox--open')) close();
    });
  }

  // ---- PDP mobile gallery: swipeable carousel + dot indicators ----
  function initPdpGallery() {
    var gallery = document.querySelector('[data-pdp-gallery]');
    var dotsWrap = document.querySelector('[data-pdp-gallery-dots]');
    if (!gallery || !dotsWrap) return;

    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-pdp-gallery-dot]'));
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.pdp__hero, .pdp__thumb'));

    function setActive(index) {
      dots.forEach(function (d, i) { d.classList.toggle('pdp__gallery-dot--active', i === index); });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-pdp-gallery-dot'), 10);
        var slide = slides[idx];
        if (slide) gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
    });

    var ticking = false;
    gallery.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var width = gallery.clientWidth || 1;
        var index = Math.round(gallery.scrollLeft / width);
        setActive(index);
        ticking = false;
      });
    });
  }

  // ---- Product card galleries: swipeable image carousel + dots, one per card ----
  function initCardGalleries() {
    var galleries = Array.prototype.slice.call(document.querySelectorAll('[data-card-gallery]'));

    galleries.forEach(function (gallery) {
      var media = gallery.closest('.product-card__media');
      var dotsWrap = media ? media.querySelector('[data-card-dots]') : null;
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('.product-card__slide'));
      if (!dotsWrap) return;

      var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-card-dot]'));

      function setActive(index) {
        dots.forEach(function (d, i) { d.classList.toggle('product-card__dot--active', i === index); });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var idx = parseInt(dot.getAttribute('data-card-dot'), 10);
          var slide = slides[idx];
          if (slide) gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });

      var ticking = false;
      gallery.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var width = gallery.clientWidth || 1;
          var index = Math.round(gallery.scrollLeft / width);
          setActive(index);
          ticking = false;
        });
      });
    });
  }

  // ---- Nav drawer: mobile menu ----
  var navDrawer = document.getElementById('NavDrawer');

  function openNavDrawer() {
    if (!navDrawer) return;
    navDrawer.classList.add('nav-drawer--open');
    navDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nav-drawer-locked');
  }

  function closeNavDrawer() {
    if (!navDrawer) return;
    navDrawer.classList.remove('nav-drawer--open');
    navDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nav-drawer-locked');
  }

  function initNavDrawer() {
    if (!navDrawer) return;

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-nav-drawer-open]')) {
        e.preventDefault();
        openNavDrawer();
        return;
      }
      if (e.target.closest('[data-nav-drawer-close]')) {
        closeNavDrawer();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && navDrawer.classList.contains('nav-drawer--open')) closeNavDrawer();
    });
  }

  // ---- Cart: AJAX add-to-cart + header count badge only.
  // The "Essential Cart Drawer" app owns the actual drawer UI (upsells, discount
  // codes, free-shipping bar) — it auto-intercepts both /cart/add(.js) requests
  // and plain links to /cart, so this theme only needs to keep the underlying
  // fetch calls working (for quick-add buttons and the PDP form) and keep the
  // header's own cart-count badge in sync. No drawer markup or rendering here.
  var cartState = null;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function fetchCart() {
    var cartUrl = (window.themeRoutes && window.themeRoutes.cart) || '/cart';
    return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refreshCart() {
    return fetchCart().then(function (cart) {
      cartState = cart;
      updateCartCount(cart.item_count);
      return cart;
    });
  }

  function addToCart(body, isFormData) {
    var url = (window.themeRoutes && window.themeRoutes.cartAdd) || '/cart/add.js';
    return fetch(url, {
      method: 'POST',
      headers: isFormData ? { 'Accept': 'application/json' } : { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { throw data; }
        return data;
      });
    });
  }

  function initCart() {
    refreshCart();

    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-add]');
      if (!addBtn) return;
      e.preventDefault();
      var variantId = addBtn.getAttribute('data-add');
      addBtn.disabled = true;
      addToCart(JSON.stringify({ id: variantId, quantity: 1 }))
        .then(function () { return refreshCart(); })
        .catch(function () {})
        .then(function () { addBtn.disabled = false; });
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      addToCart(new FormData(form), true)
        .then(function () { return refreshCart(); })
        .catch(function () {})
        .then(function () { if (submitBtn) submitBtn.disabled = false; });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPdp();
    initFilters();
    initAnchorScroll();
    initLocalizationToggle();
    initSizeGuideLightbox();
    initPdpGallery();
    initCardGalleries();
    initNavDrawer();
    initCart();
  });
})();
